import { MARQUEE_ITEMS } from "../data/content";
import { Sparkle } from "lucide-react";

const Row = ({ items, outline, reverse }) => (
  <div className="flex overflow-hidden whitespace-nowrap">
    <div className={`flex shrink-0 items-center gap-10 pr-10 ${reverse ? "animate-marquee-right" : "animate-marquee-left"}`}>
      {[...items, ...items].map((item, i) => (
        <span key={i} className="flex items-center gap-10">
          <span
            className={`font-heading text-4xl sm:text-6xl font-extrabold uppercase tracking-tight ${
              outline ? "text-outline" : "text-outline-lime"
            }`}
          >
            {item}
          </span>
          <Sparkle size={22} className={outline ? "text-[#A3E635]/40" : "text-white/20"} />
        </span>
      ))}
    </div>
  </div>
);

export const Marquee = () => (
  <section data-testid="marquee-section" className="relative border-y border-white/10 bg-[#0d1013] py-8 overflow-hidden">
    <Row items={MARQUEE_ITEMS} outline />
    <div className="h-5" />
    <Row items={[...MARQUEE_ITEMS].reverse()} reverse />
  </section>
);
